jQuery(function(){
    if(jQuery('#page-content-wrapper').height() < jQuery(window).height()) {
        var headH = jQuery('.fullwidth-page-header').height();
        var contactH = jQuery('.contacts').height();
        var footerH = jQuery('footer.content-info').height();

        jQuery('.page-content').css('min-height', jQuery(window).height() - contactH - footerH);
    }
});
